/** Wixar brand green — use Tailwind `green-500` classes where possible.
 *  This constant is for JS-only contexts (MUI sx, boxShadow, dynamic inline styles). */
export const WIXAR_GREEN = "#00c889";
export const WIXAR_GREEN_LIGHT = "#e0f5ee";

export const APK_PLATFORMS = ["MetaQuest", "OculusQuest", "PicoNeo", "Android"];
export const DESKTOP_PLATFORMS = ["Windows10", "MacOS"];

export const SPATIAL_STUDIO_PACKAGE_NAME = "com.WideWebVR.studiovrwixar";
export const SPATIAL_STUDIO_PLATFORM_IDS: Record<string, number> = {
  quest: 1,
  pico: 4,
  android: 5,
};

export const TMP_DIR = "/data/local/tmp";
export const FILE_PERMISSION = 0o644;

/** Build the device-side media cache path for a given package */
export const getMediaBasePath = (packageName: string) =>
  `/sdcard/Android/data/${packageName}/files/Medias`;

export const MEDIA_METADATA_FILES = {
  encrypted: "encrypted.txt",
  updatedTime: "mediaUpdatedTime.txt",
  presets: "presets.txt",
} as const;

export const CANCELLED_SENTINEL = "__cancelled__";
export const VERIFICATION_FAILURE_SENTINEL = "__verification_failure__";

export const POLL_INTERVAL_MS = 5_000;

export const AGENT_BASE_URL = "http://127.0.0.1:9876";
export const AGENT_WS_URL = "ws://127.0.0.1:9876/ws";
export const AGENT_POLL_INTERVAL_MS = 10_000;
export const MIN_AGENT_VERSION = "1.1.0";
export const SPATIAL_STUDIO_AGENT_ID = "spatial-studio";
export const MEDIA_MODAL_BODY_HEIGHT = "min(560px, 70vh)";
export const DEFAULT_MEDIAS_MODULE_ID = -1;

export const PROGRESS_SX = {
  height: 6,
  borderRadius: 3,
  "& .MuiLinearProgress-bar": { backgroundColor: WIXAR_GREEN, borderRadius: 3 },
  backgroundColor: WIXAR_GREEN_LIGHT,
};
